import axios from "axios";

const getConfiguracionIntegracionesFULL = async () => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Facturacion/getConfiguracionIntegracionFull`, userData);
  return response.data;
};

const configuracionIntegracionesFULL = {
  getConfiguracionIntegracionesFULL,
};

export default configuracionIntegracionesFULL;
